/**
 * Tilt Constructs - Higher level abstractions and factories for Kubernetes objects
 * 
 * 80/20 utilities that remove the most repetitive YAML/loop glue for Kubernetes manifests.
 * Assumes TypeScript runtime and K8s OpenAPI-validated builders.
 */

export * from './types';
export * from './deployment';
export * from './service';
export * from './k8s-manifest-wrapper';

export const version = "1.0.0";